<template>
  <teleport to="body">
    <div class="modalBox type1">
      <div class="inner">
        <h2 class="title">
          <slot name="header">確認提醒</slot>
        </h2>
        <p
          style="max-height: 60vh; overflow: auto; margin-bottom: 25px; white-space: pre-wrap;"
        >
          <slot name="body"></slot>
        </p>
        <div class="btns">
          <slot name="footer">
            <button class="btn" @click="$emit('yes')"><span>是</span></button>
            <button class="btn" @click="$emit('no')"><span>否</span></button>
          </slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "Confirm",
  emits: ["yes", "no"]
};
</script>
